import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

/* eslint-disable no-console */ // While in dev preview console.info will be used
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';

import FormWrapper from './styled/Form';

/** Our Form reference or API accessable by children via their form prop  */

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || _Object$getPrototypeOf(Form)).call(this, props));

    _this.onSubmit = function (event) {
      if (_this.props.onSubmit) _this.props.onSubmit(event);
    };

    _this.onValidate = function (event) {
      if (_this.props.onValidate) _this.props.onValidate(event);
    };

    _this.initFields = function () {
      return {
        fieldStates: [],
        validFields: [],
        invalidFields: [],
        isInvalid: false,
        isValidated: false,
        isSubmitted: false
      };
    };

    _this.getForm = function () {
      var _this$state = _this.state,
          name = _this$state.name,
          fields = _this$state.fields;
      var registerField = _this.registerField,
          unregisterField = _this.unregisterField,
          getFieldByName = _this.getFieldByName,
          submit = _this.submit,
          validate = _this.validate,
          reset = _this.reset;


      return {
        name: name,
        fields: fields,
        registerField: registerField,
        unregisterField: unregisterField,
        getFieldByName: getFieldByName,
        submit: submit,
        validate: validate,
        reset: reset
      };
    };

    _this.registerField = function (fieldState) {
      _this.setState(function (prevState) {
        return {
          fields: _extends({}, prevState.fields, {
            fieldStates: [].concat(_toConsumableArray(prevState.fields.fieldStates), [fieldState])
          })
        };
      });
    };

    _this.setFieldState = function () {};

    _this.unregisterField = function (name) {
      var fieldStates = _this.state.fields.fieldStates;

      var fieldState = fieldStates.find(function (field) {
        return field.name === name;
      });

      _this.setState(function (prevState) {
        return {
          fields: _extends({}, prevState.fields, {
            fieldStates: fieldStates.splice(fieldStates.indexOf(fieldState))
          })
        };
      });

      return fieldState;
    };

    _this.getFieldByName = function (name) {
      return _this.state.fields.fieldStates.find(function (fieldState) {
        return fieldState.name === name;
      });
    };

    _this.submit = function () {
      _this.form.submit();
    };

    _this.reset = function () {
      _this.form.reset();
    };

    _this.validate = function () {
      var fields = _this.getForm().fields;
      for (var i = 0; i < fields.fieldStates.length; i++) {
        if (fields.fieldStates[i].validate) fields.fieldStates[i].validate();
      }
    };

    _this.renderHeader = function () {};

    _this.renderChildren = function () {
      return React.Children.map(_this.props.children, function (child) {
        return React.cloneElement(child, {
          form: _this.getForm()
        });
      });
    };

    _this.state = {
      name: _this.props.name,
      sections: [],
      header: null,
      footer: null,
      fields: _this.initFields()
    };
    return _this;
  }

  // Reference to the form in the DOM so we can call submit, reset...


  _createClass(Form, [{
    key: 'componentDidMount',


    /** Extract Header, Footer & Sections */
    value: function componentDidMount() {}

    // EVENT HANDLERS

    /**
     * Init our form fields store
     */


    /** Returns the form state and methods accessed by children. With 16.3 we can look at using new context API */


    /**
     * Register field with this form
     */


    /** Update Field State */


    /** Remove field from form */

    /** Method to get a field by name */

    /** Submit the form after passing validation */

    /** Reset the form after passing validation */

    /** Validate all fields for the form or hand validation to custom validate handler if defined */


    /** Inject the form object into children */

  }, {
    key: 'render',


    /** The bulk of the rendering & layout for the forms childrens is done when the component mounts.
     * We inject references to the form via cloneElement
     */
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          action = _props.action,
          encType = _props.encType,
          method = _props.method,
          name = _props.name,
          target = _props.target,
          accept = _props.accept,
          acceptCharset = _props.acceptCharset,
          autoComplete = _props.autoComplete;


      return React.createElement(
        FormWrapper,
        null,
        React.createElement(
          'form',
          {
            action: action,
            encType: encType,
            method: method,
            name: name,
            target: target,
            accept: accept,
            acceptCharset: acceptCharset,
            autoComplete: autoComplete
            // $FlowFixMe Only for dev preview. TODO: resolve this type error
            , ref: function ref(form) {
              _this2.form = form;
            }
          },
          this.renderChildren()
        )
      );
    }
  }]);

  return Form;
}(Component);

Form.defaultProps = {
  onSubmit: function onSubmit() {},
  onReset: function onReset() {},
  onValidate: function onValidate() {},
  target: '_self'
};
export default Form;